import { Center, Loader } from "@mantine/core";
import { Redirect } from "wouter";
import { usePersistHydrated } from "../_Shared/usePersistHydrated";
import { useStore } from "../store";

// eslint-disable-next-line react/prop-types -- wrapper around partner routes
export default function RequirePartner({ children }) {
  const hydrated = usePersistHydrated();
  const authToken = useStore((state) => state.authToken);
  const profile = useStore((state) => state.profile);

  if (!hydrated) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }

  if (!authToken) return <Redirect to="/auth/login" />;
  if (profile && profile.role !== "MarketplacePartner") {
    return <Redirect to="/home" />;
  }
  if (!profile) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    );
  }
  return children;
}
